import { render } from "./stock-transfer-report.vue?vue&type=template&id=98cf98da&scoped=true"
import script from "./stock-transfer-report.vue?vue&type=script&lang=js"
export * from "./stock-transfer-report.vue?vue&type=script&lang=js"

import "./stock-transfer-report.vue?vue&type=style&index=0&id=98cf98da&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\personal\\ims-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98cf98da"]])

export default __exports__